import { FC, SVGAttributes } from 'react';

const Lock: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <svg {...props} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16.4218 9.94756V7.80056C16.4218 5.28756 14.3838 3.24956 11.8708 3.24956C9.35778 3.23856 7.31178 5.26656 7.30078 7.78056V7.80056V9.94756"
                stroke="#282828"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.683 21.7495H8.042C5.948 21.7495 4.25 20.0525 4.25 17.9575V13.6685C4.25 11.5735 5.948 9.87646 8.042 9.87646H15.683C17.777 9.87646 19.475 11.5735 19.475 13.6685V17.9575C19.475 20.0525 17.777 21.7495 15.683 21.7495Z"
                stroke="#282828"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.8633 14.7026V16.9236"
                stroke="#282828"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Lock;
